import React, { useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import AddDeviceDialog from "../AddDeviceDialog";

const devices = [
    { label: "스마트폰", image: "/assets/device_phones.png", category: "스마트폰" as const },
    { label: "태블릿", image: "/assets/device_tab.png", category: "태블릿" as const },
    { label: "에어팟", image: "/assets/device_airpods.png", category: "웨어러블" as const },
];

const DevicePurchaseSection: React.FC = () => {
    const [quoteOpen, setQuoteOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<'스마트폰' | '태블릿' | '웨어러블' | undefined>();

    const handleClick = (category: '스마트폰' | '태블릿' | '웨어러블') => {
        setSelectedCategory(category);
        setQuoteOpen(true);
    };

    const handleClose = () => {
        setQuoteOpen(false);
        setSelectedCategory(undefined);
    };

    return (
        <>
            <Box sx={{ py: { xs: 2, md: 3 }, background: '#fff' }}>
                <Box sx={{ maxWidth: { xs: '100%', md: '50%' }, mx: 'auto', px: { xs: 2, md: 0 } }}>
                    <Typography
                        variant="h6"
                        fontWeight={700}
                        sx={{ mb: { xs: 1.5, md: 2 }, color: '#0f172a', fontSize: { xs: '1rem', md: '1.2rem' } }}
                    >
                        기기 매입하기
                    </Typography>
                    <Grid container spacing={{ xs: 1.5, md: 2 }}>
                        {devices.map((device) => (
                            <Grid item xs={4} key={device.label}>
                                <Box
                                    onClick={() => handleClick(device.category)}
                                    sx={{
                                        background: '#f5f5f5',
                                        borderRadius: { xs: 2, md: 3 },
                                        p: { xs: 1, md: 2 },
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        overflow: 'visible',
                                        '&:hover': {
                                            transform: 'translateY(-4px)',
                                            boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                                        },
                                    }}
                                >
                                    <Typography
                                        fontWeight={600}
                                        sx={{ mb: { xs: 0.5, md: 1 }, color: '#0f172a', fontSize: { xs: '0.8rem', md: '1rem' } }}
                                    >
                                        {device.label}
                                    </Typography>
                                    <Box
                                        component="img"
                                        src={device.image}
                                        alt={device.label}
                                        sx={{
                                            width: '100%',
                                            height: { xs: 60, sm: 80, md: 100 },
                                            objectFit: 'contain',
                                            ...(device.label === '태블릿' && {
                                                transform: 'scale(1.7)',
                                            }),
                                        }}
                                    />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
            <AddDeviceDialog
                open={quoteOpen}
                onClose={handleClose}
                mode="quote"
                initialCategory={selectedCategory}
            />
        </>
    );
};

export default DevicePurchaseSection;
